import userMixin from '@/mixins/crud/computed/user'
import { defineComponent } from 'vue'

export default defineComponent({
  mixins: [userMixin],
  computed: {
    isAdmin() {
      return this.user?.roles?.includes('admin') ?? false
    },
    isManager() {
      return this.user?.roles?.includes('manager') ?? false
    },
  },
})
